import template from './product-check.template.html';
import controller from './product-check.controller';
import './product-check.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/product/product-check/product-check.component.js